/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Twitterimage1Inputs */

const ja_metadata_twitterimage1 = /** @type {(inputs: Metadata_Twitterimage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://dev.asset.playbrain.com/content-assets/defaults/playbrain-og-default-1200x630.png`)
};

const en_metadata_twitterimage1 = /** @type {(inputs: Metadata_Twitterimage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://dev.asset.playbrain.com/content-assets/defaults/playbrain-og-default-1200x630.png`)
};

/**
* | output |
* | --- |
* | "https://dev.asset.playbrain.com/content-assets/defaults/playbrain-og-default-1200x630.png" |
*
* @param {Metadata_Twitterimage1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const metadata_twitterimage1 = /** @type {((inputs?: Metadata_Twitterimage1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Twitterimage1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_metadata_twitterimage1(inputs)
	return en_metadata_twitterimage1(inputs)
});
export { metadata_twitterimage1 as "metadata_twitterImage" }